import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import UserInputField from "./components/input/user_input_field";
import Messages from "./components/messages/messages";
import Suggestion from "./components/suggestion/suggestion";
import axios from "axios";
import StartCourseBtn from "./components/buttons/start_course_btn";

const mobileCarouselImages = [
  "/images/carousel1.jpg",
  "/images/carousel2.jpg",
  "/images/carousel3.jpg",
  "/images/carousel4.jpg",
  "/images/carousel5.jpg",
  "/images/carousel6.jpg",
];

const mobileQuizQuestions = [
  {
    question: "Vad är ditt främsta mål just nu?",
    answers: [
      { text: "Gå ner i vikt och kickstarta", code: "A1" },
      { text: "Hitta balans och hållbara vanor", code: "A2" },
      { text: "Få mer energi och må bättre i vardagen", code: "A3" },
    ],
  },
  {
    question: "Hur mycket vill du gå ner i vikt?",
    answers: [
      { text: "Ca 5 kilo, vill se snabba resultat", code: "B1" },
      { text: "10-15 kilo, redo för en större förändring", code: "B2" },
      { text: "Mer än 15 kilo, vill ha en långsiktig plan", code: "B3" },
    ],
  },
  {
    question: "Hur ser din vardag ut?",
    answers: [
      { text: "Fullt upp - jag behöver enkla och snabba lösningar", code: "C1" },
      { text: "Jag gillar att laga mat och testa nya recept", code: "C2" },
      { text: "Jag vill ha tydliga scheman och struktur att följa", code: "C3" },
    ],
  },
  {
    question: "Hur viktigt är träning för dig i kursen?",
    answers: [
      { text: "Mycket viktigt - jag vill gärna kombinera med träning", code: "D1" },
      { text: "Lite - mest för att komma igång", code: "D2" },
      { text: "Fokus på kost - träning kan komma senare", code: "D3" },
    ],
  },
  {
    question: "Vad motiverar dig mest?",
    answers: [
      { text: "Snabba resultat som syns direkt på vågen", code: "E1" },
      { text: "Att bygga nya vanor steg för steg", code: "E2" },
      { text: "Att känna mig starkare, lättare och piggare", code: "E3" },
    ],
  },
];

function App() {
  const [minimized, setMinimized] = useState(true);
  const [isMobile, setIsMobile] = useState(() => {
    const parentWidthParam = new URLSearchParams(window.location.search).get("parentWidth");
    const parentWidth = parentWidthParam ? Number(parentWidthParam) : NaN;
    if (!Number.isNaN(parentWidth)) {
      return parentWidth <= 768;
    }
    return window.innerWidth <= 768;
  });
  const [chatOnlyMode, setChatOnlyMode] = useState(false);
  const [showMobileLauncherMenu, setShowMobileLauncherMenu] = useState(false);
  const [mobileSheetView, setMobileSheetView] = useState("launcher");
  const [mobileQuizStep, setMobileQuizStep] = useState(0);
  const [mobileQuizAnswers, setMobileQuizAnswers] = useState([]);
  const [mobileQuizRecommendations, setMobileQuizRecommendations] = useState([]);
  const [mobileQuizLoading, setMobileQuizLoading] = useState(false);
  const [mobileQuizError, setMobileQuizError] = useState("");
  const [mobileSheetDragOffset, setMobileSheetDragOffset] = useState(0);
  const [isDraggingMobileSheet, setIsDraggingMobileSheet] = useState(false);
  const [hasFirstMaximizeOccurred, setHasFirstMaximizeOccurred] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [threeDots, setThreeDots] = useState(false);
  const [firstRecommendation, setFirstRecommendation] = useState(true);
  const [showSuggestion, setShowSuggestion] = useState(true);
  const [hasShownNotification, setHasShownNotification] = useState(() => {
    // Check sessionStorage when component mounts
    const dismissed = sessionStorage.getItem("notificationDismissed") === "true";
    return dismissed;
  });  
  const [host, setHost] = useState(null);
  const [startCourseRecommendation, setStartCourseRecommendation] = useState(true);
  const [suggestions, setSuggestions] = useState([
    "Vad kostar en kurs?",
    "Vad ingår i Ulrikas kurser?",
    "Vilka kurser erbjuder ni?",
    "Hur lång tid tar en kurs?"
  ]);
  
  const [messages, setMessages] = useState(() => {
    const savedMessages = sessionStorage.getItem("messages");
    return savedMessages
      ? JSON.parse(savedMessages)
      : [
          {
            isUser: false,
            message:
              "Hej! Välkommen till kursväljaren! \n\n Här kan du få snabb hjälp med att välja kurs eller få svar på dina frågor. Tryck på knappen nedan för att påbörja kursväljaren, eller skriv i fältet för att ställa din fråga!",
          },
        ];
  });
  const sheetDragStartY = useRef(0);
  const openLauncherTimerRef = useRef(null);


  const callbackFromCourseSelector = async (data) => {
    setStartCourseRecommendation(true);
    data.map((course) => {
    });
  }
  
  

  const courseSelector = () => {
    console.log("Course Selector Clicked");
  }

  const startCourseSelector = () => {
    if (messages.some((msg) => msg.isCourseSelector)) {
      return;
    }

    setStartCourseRecommendation(false);
  
    setThreeDots(true);

    setMessages((prevMessages) => [...prevMessages, { isCourseSelector: true }]);
    
setTimeout(() => {
  setThreeDots(false);
}, 1000)

  }

  useEffect(() => {
    // Extract host from URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const currentHost = urlParams.get("host");

    if (currentHost) {
      
      // Ensure 'https://' is added if missing
      let fullHost = decodeURIComponent(currentHost);
      if (!fullHost.startsWith("https://")) {
        fullHost = `https://${fullHost}`;
      }
      
      setHost(fullHost);  // Set the host value with 'https://'
    }
  }, []);

  useEffect(() => {
    const applyViewportWidth = (width) => {
      if (typeof width !== "number") return;
      const mobileView = width <= 768;
      setIsMobile(mobileView);
    };

    const handleResize = () => {
      // Fallback when app is not embedded in an iframe.
      if (window === window.parent) {
        applyViewportWidth(window.innerWidth);
      }
    };

    const handleViewportMessage = (event) => {
      if (event.data?.type === "viewport" && typeof event.data.width === "number") {
        applyViewportWidth(event.data.width);
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("message", handleViewportMessage);

    if (window === window.parent) {
      applyViewportWidth(window.innerWidth);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("message", handleViewportMessage);
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("messages", JSON.stringify(messages));
  }, [messages]);

  // Handle resizing the iframe
  const handleIframeResize = (width, height) => {
    // Send a message to the parent to resize the iframe
    window.parent.postMessage({ type: 'resize', width, height }, '*');
  };

  const getLauncherIframeSize = () => {
    if (isMobile) {
      return { width: "100vw", height: "84vh" };
    }
    return { width: "390px", height: "74vh" };
  };

  const getChatOnlyIframeSize = () => {
    if (isMobile) {
      return { width: "100vw", height: "84vh" };
    }
    return { width: "390px", height: "70vh" };
  };

  const handleMinimize = () => {
    setMinimized(true);
    setShowMobileLauncherMenu(false);
    setChatOnlyMode(false);
    setMobileSheetView("launcher");
    setMobileSheetDragOffset(0);
    setIsDraggingMobileSheet(false);
    handleIframeResize("80px", "80px"); // Minimized size
  };

  const handleMaximize = () => {
    setMinimized(false);
    setShowMobileLauncherMenu(false);
    setHasShownNotification(true);
    if (isMobile) {
      handleIframeResize("100vw", "84vh");
    } else {
      handleIframeResize("390px", "74vh");
    }
  
    if (!hasFirstMaximizeOccurred) {
      setHasFirstMaximizeOccurred(true);
    }
  };

  const handleNotificationDismiss = () => {
    setShowNotification(false);
    setHasShownNotification(true);
    sessionStorage.setItem("notificationDismissed", "true");
  };

  const openLauncherMenu = () => {
    setChatOnlyMode(false);
    setMinimized(true);
    setHasShownNotification(true);
    setMobileSheetView("launcher");
    setMobileSheetDragOffset(0);
    setIsDraggingMobileSheet(false);
    if (openLauncherTimerRef.current) {
      clearTimeout(openLauncherTimerRef.current);
      openLauncherTimerRef.current = null;
    }
    setShowMobileLauncherMenu(false);
    const size = getLauncherIframeSize();
    handleIframeResize(size.width, size.height);
    openLauncherTimerRef.current = setTimeout(() => {
      setShowMobileLauncherMenu(true);
    }, 140);
  };

  const handleLauncherPress = () => {
    const nextOpenState = !showMobileLauncherMenu;
    if (nextOpenState) {
      openLauncherMenu();
    } else {
      setShowMobileLauncherMenu(false);
      handleIframeResize("80px", "80px");
    }
  };

  const closeMobileSheet = () => {
    if (openLauncherTimerRef.current) {
      clearTimeout(openLauncherTimerRef.current);
      openLauncherTimerRef.current = null;
    }
    setShowMobileLauncherMenu(false);
    setMobileSheetDragOffset(0);
    setIsDraggingMobileSheet(false);
    setMobileSheetView("launcher");
    setMobileQuizStep(0);
    setMobileQuizAnswers([]);
    setMobileQuizRecommendations([]);
    setMobileQuizLoading(false);
    setMobileQuizError("");
    handleIframeResize("80px", "80px");
  };

  const handleMobileSheetTouchStart = (event) => {
    sheetDragStartY.current = event.touches[0].clientY;
    setIsDraggingMobileSheet(true);
  };

  const handleMobileSheetTouchMove = (event) => {
    if (!isDraggingMobileSheet) {
      return;
    }

    const deltaY = event.touches[0].clientY - sheetDragStartY.current;
    setMobileSheetDragOffset(deltaY > 0 ? deltaY : 0);
  };

  const handleMobileSheetTouchEnd = () => {
    setIsDraggingMobileSheet(false);
    if (mobileSheetDragOffset > 120) {
      closeMobileSheet();
      return;
    }
    setMobileSheetDragOffset(0);
  };

  const handleMobileStartCourseSelector = () => {
    setMobileSheetView("quiz");
    setMobileQuizStep(0);
    setMobileQuizAnswers([]);
    setMobileQuizRecommendations([]);
    setMobileQuizError("");
  };

  const handleMobileAskQuestion = () => {
    setChatOnlyMode(true);
    setMinimized(false);
    setShowMobileLauncherMenu(false);
    setHasShownNotification(true);
    const size = getChatOnlyIframeSize();
    handleIframeResize(size.width, size.height);
  };

  const handleMobileAskQuestionFromResults = () => {
    if (mobileQuizRecommendations.length > 0) {
      sessionStorage.setItem("courseRecommendations", JSON.stringify(mobileQuizRecommendations));
    }
    handleMobileAskQuestion();
  };

  const handleStartCourseSelectorFromSuggestions = () => {
    setChatOnlyMode(false);
    setMobileSheetView("quiz");
    setMobileQuizStep(0);
    setMobileQuizAnswers([]);
    setMobileQuizRecommendations([]);
    setMobileQuizError("");
    setShowMobileLauncherMenu(false);
    setMinimized(true);
    const size = getLauncherIframeSize();
    handleIframeResize(size.width, size.height);
    if (openLauncherTimerRef.current) {
      clearTimeout(openLauncherTimerRef.current);
    }
    openLauncherTimerRef.current = setTimeout(() => {
      setShowMobileLauncherMenu(true);
    }, 140);
  };

  useEffect(() => {
    return () => {
      if (openLauncherTimerRef.current) {
        clearTimeout(openLauncherTimerRef.current);
      }
    };
  }, []);

  const handleMobileQuizAnswerSelect = (code) => {
    setMobileQuizAnswers((prev) => {
      const updated = [...prev];
      updated[mobileQuizStep] = code;
      return updated;
    });
  };

  const fetchMobileQuizResults = async (allAnswers) => {
    setMobileQuizLoading(true);
    setMobileQuizError("");
    try {
      const response = await axios.post(
        "https://europe-central2-ulrikadavidsson-3d8f3.cloudfunctions.net/app/api/courses",
        allAnswers
      );
      const recommendations = Array.isArray(response.data) ? response.data.slice(0, 4) : [];
      setMobileQuizRecommendations(recommendations);
      sessionStorage.setItem("courseRecommendations", JSON.stringify(recommendations));
      setMobileSheetView("results");
    } catch (error) {
      console.error("Error fetching mobile quiz recommendations:", error);
      setMobileQuizError("Något gick fel när vi hämtade resultat. Försök igen.");
    } finally {
      setMobileQuizLoading(false);
    }
  };

  const handleMobileQuizNext = async () => {
    const selectedCode = mobileQuizAnswers[mobileQuizStep];
    if (!selectedCode || mobileQuizLoading) {
      return;
    }

    if (mobileQuizStep < mobileQuizQuestions.length - 1) {
      setMobileQuizStep((prev) => prev + 1);
      return;
    }

    await fetchMobileQuizResults(mobileQuizAnswers.filter(Boolean));
  };

  const handleMobileQuizReset = () => {
    setMobileSheetView("quiz");
    setMobileQuizStep(0);
    setMobileQuizAnswers([]);
    setMobileQuizRecommendations([]);
    setMobileQuizLoading(false);
    setMobileQuizError("");
  };

  //For ulrika davidsson to open the chatbot from a link on the website
  useEffect(() => {
  const handleMessage = (event) => {
    if (event.data?.type === "openChatbot") {
      openLauncherMenu();
      return;
    }

    if (event.data?.type === "minimizeChatbot") {
      handleMinimize();
    }
  };

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, []);

  

  useEffect(() => {
    if (minimized && !hasShownNotification) {
      const timer = setTimeout(() => {
        setShowNotification(true);
        setHasShownNotification(false); // stays false until user clicks dismiss
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      setShowNotification(false);
    }
  }, [minimized, hasShownNotification]);

  const handleSuggestionClick = async (suggestion) => {
    setSuggestions([]);
    await handleUserSubmit(suggestion);
    setShowSuggestion(false);
  };

  const handleUserSubmit = async (submit) => {
    //setShowSuggestion(false);
    setMessages((prevMessages) => [...prevMessages, { isUser: true, message: submit }]);

    const updatedMessages = [...messages, { isUser: true, message: submit }];
    setThreeDots(true);
    console.log("Conversation History:");
    updatedMessages.forEach((msg, index) => {
      console.log(`Message ${index}:`, msg);
    });
    setMessages((prevMessages) => [...prevMessages, { isUser: false, message: "" }]);

    try {

      const storedCourses = sessionStorage.getItem("courseRecommendations");
      const courses = storedCourses ? JSON.parse(storedCourses) : null; // If courses exist, use them, otherwise set to null
  
      const response = await axios.post(
        "https://europe-central2-ulrikadavidsson-3d8f3.cloudfunctions.net/app/api/chat",
        {
          conversationHistory: updatedMessages,
          courses: courses || [], // If no courses, send an empty array
        }
      );

      const {content } = response.data;
      console.log("content " + content)
      const fallbackMessage = "Något gick tyvärr fel, testa igen!";
      //protects agains null or undefined
      const safeContent = content ?? fallbackMessage;

      setMessages((prevMessages) => prevMessages.slice(0, -1));

      setMessages((prevMessages) => [ ...prevMessages, { isUser: false, message: safeContent }]);


    } catch (error) {
      console.error(error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { isUser: false, message: "Hoppsan! Något gick fel, vänligen testa igen." },
      ]);
    } finally {
      setThreeDots(false);
    }
  };

  return (
    <div className={isMobile ? "kv-mode-mobile" : "kv-mode-desktop"}>
      <div className={`kursvaljarecoursewrapper ${minimized ? "kursvaljarehidden" : ""}`}>
        {chatOnlyMode ? (
          <div className="kursvaljareHeader kursvaljareHeaderQuizMode">
            <span className="kursvaljareHeaderQuizTitle">KURSVÄLJAREN</span>
            <button type="button" className="kursvaljareHeaderQuizClose" onClick={handleMinimize}>
              ×
            </button>
          </div>
        ) : (
          <div className="kursvaljareHeader">
            <img src="/images/ulrikaDavidssonIconSmaller.jpeg" alt="Diploma Icon" className="kursvaljareHeaderIcon" />
            <div className="kursvaljareIntroduction">
              <span className="chatWith">Chatta med </span>
              <span className="smilla">Ulrika Davidsson</span>
            </div>
            <img src="/images/down-arrow.svg" alt="close" className="xClose" onClick={handleMinimize} />
          </div>
        )}
        <div className="kursvaljarecontentWrapper">
          <Messages
            messages={messages}
            threeDots={threeDots}
            host={host}
            startRecommendationOnclick={handleStartCourseSelectorFromSuggestions}
            courseSelector={courseSelector}
            callbackFromCourseSelector={callbackFromCourseSelector}
            chatOnlyMode={chatOnlyMode}
          />
        </div>

        <div className="bottomContainer">
          {showSuggestion && startCourseRecommendation && (
            <Suggestion
              suggestions={suggestions}
              onClick={handleSuggestionClick}
              onStartCourseSelector={handleStartCourseSelectorFromSuggestions}
            />
          )}
           <UserInputField onSubmit={handleUserSubmit} />
        </div>
      </div>

      {minimized && (
        <>
          {showMobileLauncherMenu && (
            <>
              <div className="kursvaljareMobileLauncherBackdrop" onClick={closeMobileSheet} />
              <div
                className={`kursvaljareMobileLauncherMenu ${isDraggingMobileSheet ? "dragging" : ""}`}
                style={{ transform: `translateY(${mobileSheetDragOffset}px)` }}
                onClick={(e) => e.stopPropagation()}
              >
                {isMobile && (
                  <div
                    className="kursvaljareMobileLauncherHandleArea"
                    onTouchStart={handleMobileSheetTouchStart}
                    onTouchMove={handleMobileSheetTouchMove}
                    onTouchEnd={handleMobileSheetTouchEnd}
                  >
                    <span className="kursvaljareMobileLauncherHandle" />
                  </div>
                )}
                {mobileSheetView === "launcher" && (
                  <>
                    <div className="kursvaljareMobileLauncherContent">
                      <h3 className="kursvaljareMobileLauncherTitle">KURSVÄLJAREN</h3>
                      <p className="kursvaljareMobileLauncherText">
                        Välkommen till kursväljaren! Här kan du få snabb hjälp med att välja kurs eller få svar på dina frågor.
                      </p>
                      <div className="kursvaljareMobileLauncherCarousel">
                        <div className="kursvaljareMobileLauncherCarouselTrack">
                          {[...mobileCarouselImages, ...mobileCarouselImages].map((imageSrc, index) => (
                            <img key={`${imageSrc}-${index}`} src={imageSrc} alt={`Kursbild ${index + 1}`} />
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="kursvaljareMobileLauncherActions">
                      <button className="kursvaljareMobileLauncherPrimary" onClick={handleMobileStartCourseSelector}>
                        STARTA KURSVÄLJAREN
                      </button>
                      <button className="kursvaljareMobileLauncherSecondary" onClick={handleMobileAskQuestion}>
                        STÄLL EN FRÅGA OM KURSER
                      </button>
                      <button className="kursvaljareMobileLauncherClose" onClick={closeMobileSheet}>
                        AVSLUTA KURSVÄLJAREN
                      </button>
                    </div>
                  </>
                )}

                {mobileSheetView === "quiz" && (
                  <div className="kursvaljareMobileQuiz">
                    <div className="kursvaljareMobileQuizHeader">
                      <h3>KURSVÄLJAREN</h3>
                      <button type="button" onClick={closeMobileSheet}>×</button>
                    </div>

                    <div className="kursvaljareMobileQuizBody">
                      <p className="kursvaljareMobileQuizStep">
                        FRÅGA {mobileQuizStep + 1} / {mobileQuizQuestions.length}
                      </p>
                      <p className="kursvaljareMobileQuizQuestion">
                        {mobileQuizQuestions[mobileQuizStep].question}
                      </p>

                      <div className="kursvaljareMobileQuizAnswers">
                        {mobileQuizQuestions[mobileQuizStep].answers.map((answer) => (
                          <button
                            key={answer.code}
                            type="button"
                            className={`kursvaljareMobileQuizAnswer ${mobileQuizAnswers[mobileQuizStep] === answer.code ? "selected" : ""}`}
                            onClick={() => handleMobileQuizAnswerSelect(answer.code)}
                          >
                            {answer.text}
                          </button>
                        ))}
                      </div>

                      {mobileQuizError && <p className="kursvaljareMobileQuizError">{mobileQuizError}</p>}
                    </div>

                    <button
                      type="button"
                      className="kursvaljareMobileQuizNext"
                      onClick={handleMobileQuizNext}
                      disabled={!mobileQuizAnswers[mobileQuizStep] || mobileQuizLoading}
                    >
                      {mobileQuizLoading
                        ? "LADDAR..."
                        : mobileQuizStep === mobileQuizQuestions.length - 1
                          ? "VISA RESULTAT"
                          : "NÄSTA FRÅGA"}
                    </button>
                  </div>
                )}

                {mobileSheetView === "results" && (
                  <div className="kursvaljareMobileResults">
                    <div className="kursvaljareMobileQuizHeader">
                      <h3>KURSVÄLJAREN</h3>
                      <button type="button" onClick={closeMobileSheet}>×</button>
                    </div>

                    <div className="kursvaljareMobileResultsBody">
                      <p className="kursvaljareMobileQuizStep">RESULTAT</p>
                      <p className="kursvaljareMobileResultsText">
                        Baserat på dina svar matchar dessa kurser dina behov.
                      </p>

                      <div className="kursvaljareMobileResultsGrid">
                        {mobileQuizRecommendations.map((course) => (
                          <a key={course.id} href={course.link} target="_top" className="kursvaljareMobileResultCard">
                            <img src={course.og_image_url} alt={course.name} />
                            <span>{course.name}</span>
                          </a>
                        ))}
                      </div>
                    </div>

                    <div className="kursvaljareMobileResultsActions">
                      <button type="button" className="kursvaljareMobileLauncherPrimary" onClick={handleMobileAskQuestionFromResults}>
                        STÄLL EN FRÅGA OM KURSER
                      </button>
                      <button type="button" className="kursvaljareMobileLauncherClose" onClick={handleMobileQuizReset}>
                        GÖR OM TEST
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          <div className={`kursvaljareminimizedButton ${showMobileLauncherMenu ? "sheetOpen" : ""}`} onClick={handleLauncherPress}>
            <img src="/images/ulrikaDavidssonIconSmaller.jpeg" alt="Diploma" className="kursvaljareImage kursvaljareMinimizedAvatar" />
            <span className="kursvaljareBottomBarLabel">KURSVÄLJAREN</span>
          </div>

          {showNotification && !showMobileLauncherMenu && (
            <div className="kursvaljareNotificationBubble" onClick={handleNotificationDismiss} onTouchStart={handleNotificationDismiss}>
              <p>Psst! Har du svårt att veta vilken kurs som passar dig? Tryck på mig!</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default App;
